import React, { FC } from "react"
import { Col, Row } from "react-bootstrap"
import { useSelector } from "react-redux"

import { ReservedFields } from "@/onboarding/features/product/models/Product"
import Field from "@/onboarding/features/product/components/shared/Field"
import { hasProductField } from "@/onboarding/features/product/selectors"

const Content: FC = () => {
  const hasMeetingLocation = useSelector(hasProductField(ReservedFields.MEETING_LOCATION))
  const hasAnchoredBuffer = useSelector(
    hasProductField(ReservedFields.MEETING_TIME_BUFFER_ANCHORED)
  )
  const hasDockedBuffer = useSelector(hasProductField(ReservedFields.MEETING_TIME_BUFFER_DOCKED))

  return (
    <div className="d-flex flex-column gap-3">
      <Row>
        <Col md={4}>
          <Field name={ReservedFields.START_LOCATION} label="Start Location" />
        </Col>
        {hasMeetingLocation && (
          <Col md={4}>
            <Field name={ReservedFields.MEETING_LOCATION} label="Meeting Location" />
          </Col>
        )}
        <Col md={4}>
          <Field name={ReservedFields.TOUR_DURATION} label="Tour Duration (minutes)" />
        </Col>
      </Row>
      {(hasAnchoredBuffer || hasDockedBuffer) && (
        <Row>
          {hasAnchoredBuffer && (
            <Col md={4}>
              <Field
                name={ReservedFields.MEETING_TIME_BUFFER_ANCHORED}
                label="Meeting Time - Anchored"
                helpText="Minutes before departure"
              />
            </Col>
          )}
          {hasDockedBuffer && (
            <Col md={4}>
              <Field
                name={ReservedFields.MEETING_TIME_BUFFER_DOCKED}
                label="Meeting Time - Docked"
                helpText="Minutes before departure"
              />
            </Col>
          )}
        </Row>
      )}
    </div>
  )
}

export default Content
